import React, {useState} from 'react'
import AddCard from './AddCard'
import '../styles/styles.css'
import '../styles/global.css'
import '../styles/newset.css'

const NewSet = (props) => {
    const [numTopics, setNumTopics] = useState([])
    const [nameOfTopic, setNameOfTopic] = useState('')
    const { studyTitle } = props.location.state
    const [showTopic, setShowTopic] = useState([])

    const handleForm = (e) => {
        e.preventDefault()
        if(nameOfTopic.length < 1) {
            alert("Please fill out the form with proper values")
        }
        else{
            setNumTopics([...numTopics, {id: Math.floor(Math.random()*151), topicName: nameOfTopic}])
        }
    }


    const removeElement = (topicName) => {
        const filteredArr = showTopic.filter(topic => topic.id !== topicName)
        setShowTopic(filteredArr)
    }

    const ShowTopic = (topic) => {
      //  currentTopicId = topicId;
      //  alert(currentTopicId);
        //const result = showTopic.filter(baseTopic => baseTopic.topicName !== topic.topicName);
      //  console.log(result)
      if(showTopic.length === 0) {
          setShowTopic([...showTopic, topic])
          return
      }
      for(let i = 0; i < showTopic.length; i++) {
          if(showTopic[i].id === topic.id) {
            removeElement(topic.id)
            return
          } else {
              setShowTopic([...showTopic, topic])
          }
      }

    }

    return (
        <div className="has-text-centered">

            <div className="sideBar">
                <div className="sideBarPadding">
                    <h2>Add Topics</h2>
                    <p>
                        Add a new topic to this study set. Topics are essentially subcategories for your study set.
                    </p>
                    <form onSubmit={handleForm}>
                        <input placeholder="Definitions, Equations, Text, etc." className="blueTextInput" name="numTopics" id="numTopics" type="text" onChange={e => setNameOfTopic(e.target.value)} />
                        <input type="submit" value="Add Topic" className="tealBtn"/>
                    </form>
                </div>
                <div>
                {numTopics.filter(topic => topic !== null).map((topic, i) => (
                    <div key={topic.id} className="topicBtn" onClick={() => ShowTopic(topic)}>
                        {topic.topicName}
                    </div>
                ))}
                </div>
            </div>


            <div>

                <div className="heroContainer">
                    <h1>{studyTitle}</h1>
                    <p>Add content and valuable information to your study set.</p>
                </div>

                <div>
                    {showTopic.map((topic, index) => (
                        <div key={index}>
                          <div key={topic.id}>
                              <ul key={topic.id}>
                              <li key={topic.id}>
                              <div key={topic.id} style={{paddingTop: '2.5%'}}>
                                  <AddCard key={topic.id}  studyTitle={studyTitle} topic={topic}/>
                              </div>
                              </li>
                              </ul>
                          </div>
                        </div>
                    ))}
                    {/*numTopics.filter(topic => topic !== null).map((topic, i) => (
                        <div key={topic.id}>
                            <ul key={topic.id}>
                            <li key={topic.id}>
                            <div key={topic.id} style={{paddingTop: '2.5%'}}>
                                <AddCard key={topic.id}  studyTitle={studyTitle} topic={topic}/>
                            </div>
                            </li>
                            </ul>
                        </div>
                    ))*/}
                </div>

            </div>



  </div>

    )
}//<AddContent key={topic.id}  topic={topic}/>
export default NewSet
